<template>
	  <div class="comment-area">
	    <el-input v-model="commentContent" placeholder="请输入评论内容" @keyup.enter.native="submitComment" clearable>
	      <el-button slot="append" icon="el-icon-position" @click="submitComment" ></el-button>
	    </el-input>
		 <div class="comment-list" v-loading="loading">
	      <div v-for="(comment, index) in comments" :key="index" class="comment-item">
	      
		<div class="avatar">
		        <img :src="comment.avatar" alt="Avatar">
		      </div>
		      <div class="content">
		        <div class="meta">
		          <span class="author">{{ comment.nickname }}</span>
		          <span class="time">{{ comment.timeDesc }}</span>
		        </div>
		        <div class="text" style="background-color: #f0f0f0;">
		          {{ comment.content }}
		        </div>
		      </div>
	      </div>
		  <div style="text-align: center;">
			  <el-button @click="loadComment(1)" >加载更多</el-button>
			  
		  </div>
	    </div>
	  </div>
</template>

<script>
	export default{
		props:{
			menuId:String,
			home:Object
		},
		data(){
			return{
				loading:false,
				  commentContent: '',
				      comments: [],
				commentData: [],
				page:0,
				limit:6,
				userInfo:{}
			}
		},
		methods:{
			    submitComment() {
			      if (this.commentContent.trim() === '') {
			        return; // 空内容不提交评论
			      }
			if(this.commentContent.trim().length>50){
				this.$notify({
				      title: '消息提示',
				      message: '评论不要大于50字！',
											   type: 'error'
				    });
					return;
			}
			      // 模拟提交评论的操作，将评论添加到评论列表
			      const newComment = {
			        userId: this.userInfo.id,
			        content: this.commentContent
			      };
			     this.$api.saveComment(newComment).then(res=>{
					 if(res.data.code==200){
						 this.$notify({
						       title: '消息提示',
						       message: '提交评论成功！',
							   type: 'success'
						     });
							 this.page=0;
							 this.comments=[]
							 this.loadComment();
					 }else{
						 this.$notify({
						       title: '消息提示',
						       message: '提交评论失败！',
						 							   type: 'error'
						     });
					 }
				 })
			
			      // 发表评论后清空评论输入框
			      this.commentContent = '';
			    },
	loadComment(type){
		this.loading=true
		this.page++
	this.$api.getCommentPage({page:this.page,limit:this.limit,status:1}).then(res=>{
		if(res.data.data.length==0){
			this.page--
			if(type==1){
			this.$notify.info({
			      title: '消息提示',
			      message: '没有更多评论'
			    });
				}
		}else{
		res.data.data.forEach(item=>{
			 this.comments.push(item);
		})
		}
this.loading=false
	})
	}
		},
		mounted() {
			this.loadComment()
			let info=localStorage.getItem("userInfo")
			this.userInfo=JSON.parse(info)
		}
	}
</script>

<style scoped>
.comment-area {
		  margin: auto;
	  width: 40%;
  margin-bottom: 20px;
}

.comment-list {
  margin-top: 10px;
}

.comment-item {
  margin-bottom: 10px;

}

.comment-author {
  font-weight: bold;
  padding-left: 10px;
}
.comment-time {
  color: grey;
  padding-left: 5px;
}
.comment-content {
  margin-top: 5px;
   padding-left: 10px;
}
.comment {
  display: flex;
  margin-bottom: 10px;
}

.avatar img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.content {
  margin-left: 10px;
  flex-grow: 1;
}

.meta {
  font-size: 12px;
  color: #999;
}

.author {
  margin-right: 5px;
}

.text {
  padding: 10px;
  border-radius: 5px;
  color: #333;
  font-size: 14px;
}
</style>